<!-- 首页手机注册框 -->
<template>
  <div>
    <!-- 上拉框 -->
    <vanActionSheet
      v-model="show"
      :closeable="false"
      @cancel="onCancel"
    >
      <div class="sheet-title">
        注册
      </div>
      <div
      >
        <elForm
          ref="form"
          :model="form"
          class="normal-form no-show-required"
          :rules="rules"
          @submit.native.prevent
        >
          <!-- 姓名 -->
          <elFormItem prop="userName">
            <elInput
              v-model="form.userName"
              maxlength="11"
              clearable
              placeholder="请输入真实姓名，输入错误将无法发起提现"
            >
              <img class="input-icon" slot="prefix" :src="nameIcon"/>
            </elInput>
          </elFormItem>
          <!-- 手机号 -->
          <elFormItem  prop="phone">
            <elInput
              v-model="form.phone"
              maxlength="11"
              clearable
              placeholder="请输入您的手机号码"
              class="phone-input"
            >
              <span slot="prefix">
                 <img class="input-icon"  :src="phoneIcon"/>
                 <span class="phone-prefix">+86</span>
              </span>
            </elInput>
          </elFormItem>

          <!-- 验证码 -->
          <elFormItem
            class="verify-input"
            prop="verifyCode"
          >
            <elInput
              v-model="form.verifyCode"
              placeholder="请输入手机验证码"
            >
              <img class="input-icon verify-code-icon" slot="prefix" :src="codeIcon"/>
              <getVerifyCode
                slot="append"
                :isdisable="!form.phone"
                :phone="form.phone"
                :type="4"
                @checkPhone="checkPhone"
              ></getVerifyCode>
            </elInput>
          </elFormItem>
        </elForm>
        <div class="flex-center">
          <van-button
            :loading="submitLoading"
            class="bind-btn"
            @click="bindPhone"
            round
          >
            注册
          </van-button>
        </div>
      </div>
    </vanActionSheet>
  </div>
</template>

<script>
import getVerifyCode from '@/components/getVerifyCode'
import { apiPost } from '@/services'
import codeIcon from '@/assets/images/home/codeIcon.png'
import nameIcon from '@/assets/images/home/nameIcon.png'
import phoneIcon from '@/assets/images/home/phoneIcon.png'

const defaultData = {
    phone: '',
    userName: '',
    verifyCode: ''
}
export default {
  name: 'registeredSheet',

  components: { getVerifyCode },

  props: {
  },
  data() {
    var validatePhone = (rule, value, callback) => {
       if (value) {
          const regex = /^1[3-9]\d{9}$/
          if (regex.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确的手机号码'))
          }
       } else {
          callback(new Error('请输入正确的手机号码'))
       }
    }
    return {
      // 模态框状态
      show: false,
      submitLoading: false,
      form: { ...defaultData },
      codeIcon,
      nameIcon,
      phoneIcon,
      rules: {
        userName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入正确的手机号码', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur'] }
        ],
        // 开户银行
        verifyCode: [
          { required: true, message: '请输入正确的验证码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 打开modal
    openModal() {
      this.show = true
    },
    // 取消事件
    onCancel() {
      this.show = false
      this.$emit('onCancel')
    },
    checkPhone(fn) {
      this.$refs.form.validateField(['phone'], (err) => {
        if (!err) {
          fn()
        }
      })
    },
    // 绑定手机号
    bindPhone() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          apiPost('partner/open/addPartnerPhone', this.form)
          .then(res => {
            if (res.code === '0000') {
              this.$notify.success(res.msg)
              this.$emit('onSuccess')
              this.show = false
            } else {
              this.$notify.error(res.msg)
            }
          }).then(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.van-action-sheet__content {
  padding: 30px 26px;
  padding-bottom: 0;
  background: #fff;
  .el-input__inner {
    background: #fff;
  }
  .el-input {
    input {
      color: #302B3E;
      padding-left: 45px;
      font-size: 14px;
      font-weight: 600;
      &::placeholder {
        color: #666666;
        font-size: 10px;
      }
    }
    .input-icon{
      width: 21px;
      height: auto;
    }
    .verify-code-icon{
      margin-top: 4px;
    }
  }
  .phone-input{
    input{
      padding-left: 75px;
    }
    .phone-prefix{
      position: absolute;
      left: 40px;
      top: 1px;
      font-size: 14px;
      color: #302B3E;
      font-weight: 600;
      line-height: 21px;
    }
  }
  .el-form-item {
    border-bottom: 1px solid #E5E5E5;
  }
  .el-form-item .el-form-item__content {
    line-height: normal;
  }
  .el-form-item__error {
    color: #e4918d;
  }
  .flex-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-form {
    margin: 0;
    padding-bottom: 10px;
  }
  .verify-input {
    .el-form-item__label {
      padding-bottom: 0;
    }
    .el-input {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .el-input__inner{
        flex: 1;
      }
    }
  }
  .sheet-title {
    font-size: 22px;
    font-weight: 800;
    line-height: 26px;
    color: #302B3E;
    padding-bottom: 30px;
  }
  .bind-btn {
    width: calc(100% - 30px);
    font-size: 16px;
    margin: 0 auto;
    margin-top: 65px;
    background: #FFB600;
    height: 44px;
    font-weight: 600;
    color: #302B3E;
    border: none;
    margin-bottom: 20px;
    &.van-button--disabled {
      background: #444757;
      border: 0.5px solid #9f9f9f;
    }
  }
}
</style>
